import { configureStore } from '@reduxjs/toolkit';
import chatReducer from './slices/sessionSlice.js';
import modelReducer from './slices/modelSlice.js';
import generatingReducer from './slices/generatingSlice.js';
import websocketReducer from './slices/websocketSlice.js';
import chatObjectsReducer from './slices/chatObjectsSlice.js';
import chatUserObjectsReducer from './slices/chatUserObjects.js';
import userReducer from './slices/userSlice.js';
import organizationReducer from './slices/organizationSlice.js';
import isEditingReducer from './slices/isEditingSlice.js';
import draftRecordReducer from './slices/draftRecordSlice.js';
import flashFieldsReducer from './slices/flashFieldsSlice.js';
import validationReducer from './slices/validationSlice.js';
import uiReducer from './slices/uiSlice.js';
import feedbackReducer from './slices/feedbackSlice.js';
import notificationReducer from './slices/notificationSlice.js';
import instructionsReducer from './slices/instructionsSlice.js';
import dynamicUiReducer from './slices/dynamicUiSlice.js'; /* NEW */

const store = configureStore({
  reducer: {
    chat: chatReducer,
    model: modelReducer,
    generating: generatingReducer,
    websocket: websocketReducer,
    chatObjects: chatObjectsReducer,
    chatUserObjects: chatUserObjectsReducer,
    user: userReducer,
    organization: organizationReducer,
    isEditing: isEditingReducer,
    draftRecord: draftRecordReducer,
    flashFields: flashFieldsReducer,
    validation: validationReducer,
    ui: uiReducer,
    feedback: feedbackReducer,
    notifications: notificationReducer,
    instructions: instructionsReducer,
    dynamicUi: dynamicUiReducer, /* NEW */
  },
});

export default store;